import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomerVoiceRouterService } from '../core/cv-router.service';
import { Customer } from '../customers/customer-common';
import {
  CreateReviewRequestEventRequest,
  CustomerRequestEvent,
  CustomerVoiceApiService,
  RequestEventType,
  ReviewRequestEvent,
} from '@vendasta/customer-voice-service';

@Injectable()
export class ReviewRequestEventService {
  constructor(
    private customerVoiceApiService: CustomerVoiceApiService,
    private customerVoiceRouterService: CustomerVoiceRouterService,
  ) {}

  public createReviewRequestEventFromCustomers(
    customers: Customer[],
    requestType: RequestEventType,
  ): Observable<ReviewRequestEvent> {
    const customerRequestEvents: CustomerRequestEvent[] = customers.map((c) => {
      return {
        customerId: c.contactId,
        requestEventType: requestType,
      } as CustomerRequestEvent;
    });
    return this.createReviewRequestEvent(customerRequestEvents);
  }

  public createReviewRequestEvent(customerRequestEvents: CustomerRequestEvent[]): Observable<ReviewRequestEvent> {
    return this.customerVoiceRouterService.accountGroupId.pipe(
      switchMap((businessId) => {
        const request = new CreateReviewRequestEventRequest({
          businessId: businessId,
          customerRequestEvents: customerRequestEvents,
        });
        return this.customerVoiceApiService.createReviewRequestEvent(request);
      }),
      map((response) => response.reviewRequestEvent),
    );
  }
}
